import { createContext, useMemo, useState } from "react";

export const AppConfigContext = createContext(null);

export default function AppConfigProvider({ children }) {
  // Keep only global knobs you truly need everywhere
  const [selectedGptModel, setSelectedGptModel] = useState("gpt-4o"); // or "gpt-5"
  const [selectedMaxTokens, setSelectedMaxTokens] = useState(6000);
  const [selectedTemperature, setSelectedTemperature] = useState(0.4);
  const [batchQuantity, setBatchQuantity] = useState(50);

  const value = useMemo(() => ({
    selectedGptModel, setSelectedGptModel,
    selectedMaxTokens, setSelectedMaxTokens,
    selectedTemperature, setSelectedTemperature,
    batchQuantity, setBatchQuantity,
  }), [selectedGptModel, selectedMaxTokens, selectedTemperature, batchQuantity]);

  return (
    <AppConfigContext.Provider value={value}>
      {children}
    </AppConfigContext.Provider>
  );
}
